import { Component, Input, OnChanges } from '@angular/core'
import { TranslatePipe } from '@ngx-translate/core'
import { SvgIconComponent } from 'angular-svg-icon'

import { User } from '../../models/user.model'
import { HighLightTextPipe } from '../../pipes/high-light-text.pipe'

@Component({
  selector: 'app-user',
  imports: [HighLightTextPipe, SvgIconComponent, TranslatePipe],
  templateUrl: './user.component.html',
})
export class UserComponent implements OnChanges {
  @Input({ required: true }) public userMail!: string
  @Input({ required: false }) public users?: User[]
  @Input({ required: true }) public highlight!: string

  public user!: {
    email: string
    abbreviation: string
  }

  public ngOnChanges(): void {
    const email = this.userMail
    const parts = email.split('@')[0].split('.')
    this.user = {
      email: email,
      abbreviation:
        parts[0][0].toUpperCase() +
        (parts[1]?.[0] ?? parts[0][1]).toUpperCase(),
    }
  }
}
